module.exports = __webpack_public_path__ + "static/g9-8a6f848488de6a36a3ec4ede08ff5364.jpg";